var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62917 0.999998C5.39897 -0.333335 7.32347 -0.333334 8.09327 1L11.9904 7.75C12.7602 9.08334 11.7979 10.75 10.2583 10.75H2.4641C0.924499 10.75 -0.0377496 9.08333 0.732051 7.75L4.62917 0.999998Z",
    fill: "#3E3E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleTooltip);
export default __webpack_public_path__ + "static/media/TriangleTooltip.9f29778cc71b3f7df5df5bc31f37fc4e.svg";
export { ForwardRef as ReactComponent };